import React from 'react';
import { CalendarPlus, Mic } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const EventSection = () => {
  const { t } = useLanguage();

  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="evenement" className="bg-[#3f4816] py-20 md:py-28">
      <div className="max-w-[87.5rem] mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-12 items-center">
          {/* Content */}
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-black text-[#d9fb06] text-3xl sm:text-4xl md:text-5xl lg:text-6xl uppercase leading-[0.85] mb-6">
              {t.event.title}
            </h2>
            <p className="text-[#d9fb06]/80 text-base md:text-lg lg:text-xl leading-relaxed mb-8 max-w-2xl mx-auto lg:mx-0">
              {t.event.description}
            </p>
            <button
              onClick={scrollToContact}
              className="bg-[#d9fb06] text-[#1a1c1b] rounded-full px-6 sm:px-8 py-4 font-semibold text-sm uppercase tracking-wide hover:scale-[1.02] active:scale-[0.98] transition-transform inline-flex items-center gap-2"
            >
              {t.event.cta}
              <CalendarPlus className="w-4 h-4" />
            </button>
          </div>

          {/* Icon illustration */}
          <div className="flex-shrink-0">
            <div className="w-40 h-40 md:w-56 md:h-56 rounded-full border-2 border-[#d9fb06]/30 flex items-center justify-center relative">
              <div className="absolute inset-0 rounded-full border border-[#d9fb06]/10" style={{ transform: 'scale(1.2)' }} />
              <div className="flex gap-4">
                <Mic className="w-10 h-10 md:w-14 md:h-14 text-[#d9fb06]" />
                <CalendarPlus className="w-10 h-10 md:w-14 md:h-14 text-[#d9fb06]" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EventSection;
